<label class="flex items-center" [ngClass]="{'disabled': _disabled, 'cursor-pointer': !_disabled, 'flex-row-reverse justify-between' : reversed }">
  <div class="relative" [ngClass]="{'disabled:opacity-25': disabled}">
    <input type="checkbox" class="sr-only" [disabled]="_disabled" [(ngModel)]="_value" (change)="switch()" />
    <div class="slide" [ngClass]="{'opacity-60': _disabled}"></div>
    <div class="dot" [ngClass]="{'opacity-60': _disabled}"></div>
  </div>
  <div [ngClass]="{'ml-3' : !reversed}"><ng-content></ng-content></div>
</label>
